import React, { FC, Children, ReactElement } from "react";
import { Container } from "@UI/Components/Container/Container";
import { Box, BoxProps } from "@UI/Components/Box/Box";
import { DottedJumbotron } from "@UI/Components/DottedJumbotron/DottedJumbotron";
import { SlideFade } from "@UI/Components/Transition/Transition";

type Props = BoxProps;
type NavProps = BoxProps;
type HeaderProps = BoxProps;
type ContentProps = BoxProps;

export const WizardNav: FC<NavProps> = (props) => (
  <Box paddingBottom={{ base: 5, md: 8 }} {...props} />
);
export const WizardHeader: FC<HeaderProps> = ({ children, ...props }) => (
  <Box
    textAlign={{ base: "start", lg: "center" }}
    marginBottom={{ base: 4, md: 8 }}
    {...props}
  >
    {children}
  </Box>
);

export const WizardContent: FC<ContentProps> = (props) => <Box {...props} />;

export const Wizard: FC<Props> = ({ children, ...props }) => {
  const slots = {
    nav: undefined,
    header: undefined,
    content: undefined,
  };

  Children.forEach(children, (child: ReactElement) => {
    if (child.type === WizardNav) {
      slots.nav = child;
    } else if (child.type === WizardHeader) {
      slots.header = child;
    } else if (child.type === WizardContent) {
      slots.content = child;
    } else {
      throw new Error(
        "Wizard can only contain WizardNav, WizardHeader, and WizardContent components"
      );
    }
  });

  return (
    <DottedJumbotron>
      <Container
        paddingTop={{ base: 5, md: slots.nav ? 8 : 14 }}
        paddingBottom={{ base: 10, md: 20 }}
        maxW={{
          base: "container.lg",
          sm: "container.sm",
          lg: "container.lg",
        }}
        minHeight="85vh"
        {...props}
      >
        <SlideFade
          in
          transition={{ enter: { duration: 0.1 } }}
          offsetX="100"
          offsetY="0"
          unmountOnExit
        >
          {slots.nav}
          {slots.header}
          {slots.content}
        </SlideFade>
      </Container>
    </DottedJumbotron>
  );
};
